module.exports = __webpack_public_path__ + "static/logo-dapen-telkom-a3910baddc68ddd89a990ec18bbefe9b.png";